class SvcsScreenMealItem {
    constructor($el, options) {
        const that = this;

        // DOM
        that.$el = $el;
        that.$button_add  = that.$el.find('.js-meal-item-add');
        that.$button_edit = that.$el.find('.js-meal-item-edit');
        that.$badge_added = that.$el.find('.js-svc-badge-added');
        that.$badge_added_quantity = that.$el.find('.js-svc-badge-added-quantity');

        const { item_id, segment_id, meal_segment, passengers, modal_html } = options;

        // CONST
        that.modal_html = modal_html;
        that.passengers = passengers;

        that.category_id  = $el.data('category-id') + '';
        that.meal_item_id = item_id;
        that.segment_id   = segment_id;

        that.meal_segment = meal_segment;
        that.meal_item    = that.meal_segment.meal_items[that.meal_item_id];

        that.price        = that.meal_item.price;
        that.currency     = that.meal_item.currency;

        // VARS
        that.quantity = Object.values(that.passengers).reduce( function(count, passenger) {
            return count + passenger.quantity;
        }, 0);

        // FUNCTIONS
        /**
         * @type {Function}
         * */
        that.onChange = (typeof options['onChange'] === 'function' ? options['onChange'] : function() {});

        that.#init();
    }

    #init() {
        const that = this;

        that.$el.on('click', function(event) {
            event.preventDefault();
            that.showModal();
        });

        that.#render();

        that.$el.data('meal_item', that);
    }

    /**
     * Используется при фильтрации категорий в шапке раздела
     * */
    display(show) {
        const that = this;

        if (show) {
            that.$el.show();
        } else {
            that.$el.hide();
        }
    }

    update(data) {
        const that = this;

        that.quantity = data.quantity;

        $.each(data.passengers, function(i, passenger) {
            const old_quantity = that.passengers[passenger.id].quantity,
                  new_quantity = passenger.quantity,
                  is_changed = (old_quantity !== new_quantity);

            if (!is_changed) { return; }

            const item_data = {
                item_id: that.meal_item_id,
                currency: that.currency,
                item_quantity: new_quantity,
                item_quantity_diff: (new_quantity - old_quantity),
                item_price: that.price,
                passenger_id: passenger.id,
                segment_id: that.segment_id
            };

            that.onChange(item_data, that);

            that.passengers[passenger.id].quantity = new_quantity;
        });

        that.#render();
    }

    showModal() {
        const that = this;

        $.uiModal({
            html: that.#getModalHtml(),
            mobile_fullscreen: true,
            onOpen: initModal,
            onSubmit: function(data) {
                that.update(data);
            }
        });

        function initModal($modal, modal) {
            // DOM
            const $counters = $modal.find('.js-counter-input'),
                  $price = $modal.find('.js-direction-price'),
                  $button = $modal.find('.js-success-button');

            render();

            const is_mobile = $.sa.is_mobile();
            if (is_mobile) {
                setTimeout(function() {
                    modal.resize();
                }, 200);
            }

            // EVENTS

            $modal.on(UICounter.prototype.custom_events.value_changed, render);

            $button.on('click', function(event) {
                event.preventDefault();
                const data = getData();
                modal.options.onSubmit(data);
                modal.close();
            });

            // FUNCTIONS

            function render() {
                const { quantity } = getData();

                // Price and submit button
                if (quantity > 0) {
                    const total = quantity * that.price,
                          price_html = $.sa.format.price(total, that.currency);

                    $price.html(price_html);
                    $button.text($.sa.locales['confirm']);

                } else {
                    const price_html = $.sa.format.price(0, that.currency);

                    $price.html(price_html);
                    $button.text($.sa.locales['continue_without_service']);
                }

                // Counter background
                $.each($counters, function() {
                    const $input = $(this),
                          $passenger = $input.closest('.js-passenger-wrapper'),
                          $counter = $passenger.find('.js-counter'),
                          active_class = 'is-active',
                          is_active = $passenger.hasClass(active_class);

                    let value = parseInt($input.val());
                    if (value > 0) {
                        if (!is_active) {
                            $passenger.addClass(active_class);
                        }
                    } else {
                        if (is_active) {
                            $passenger.removeClass(active_class);
                        }
                    }
                    UICounter.prototype.set($counter, value, true, false);
                });
            }

            function getData() {
                const passengers = [];

                let quantity = 0;

                $.each($counters, function() {
                    const $input = $(this),
                          $passenger = $input.closest('.js-passenger-wrapper');

                    const passenger_id = $passenger.data('passenger-id') + '';

                    let value = parseInt($input.val());

                    if (value > 0) {
                        quantity += value;
                    } else {
                        value = 0;
                    }

                    passengers.push({
                        id: passenger_id,
                        quantity: value
                    });
                });

                return {
                    quantity,
                    passengers
                };
            }
        }
    }

    removeMealItem() {
        const that = this;

        const passengers = Object.values(that.passengers).map( function(passenger) {
            return {
                id: passenger.id,
                quantity: 0
            };
        });

        that.update({
            quantity: 0,
            passengers
        });
    }

    /**
     * @description Рендер продукта
     * */
    #render() {
        const that = this;

        if (that.quantity > 0) {
            that.$button_add.hide();
            that.$button_edit.show();

            that.$badge_added_quantity.text('x' + that.quantity);
            that.$badge_added.show();

        } else {
            that.$button_add.show();
            that.$button_edit.hide();

            that.$badge_added_quantity.text('');
            that.$badge_added.hide();
        }
    }

    /**
     * @description получаем HTML модалки с подстановкой данных
     * @return {String}
     * */
    #getModalHtml() {
        const that = this;

        const { nl2br, localeField } = $.sa.utils;

        const airline_svc = that.meal_item.airline_svc,
              segment = that.meal_segment.segment,
              departure_date = segment['_departure_local'];

        let html = that.modal_html
            .replace(/{ { meal_item_img_path } }/g, airline_svc.img_path)
            .replace(/{ { meal_item_name } }/g, localeField(airline_svc, 'name'))
            .replace(/{ { meal_item_hint } }/g, nl2br(localeField(airline_svc, 'hint')))
            .replace(/{ { meal_item_description } }/g, nl2br(localeField(airline_svc, 'description')))
            .replace(/{ { date_day } }/g, departure_date.weekday)
            .replace(/{ { date_month } }/g, departure_date['date_month'])
            .replace(/{ { departure_city_name } }/g, localeField(segment.departure_airport.city, 'name'))
            .replace(/{ { departure_airport_code } }/g, segment.departure_airport_code)
            .replace(/{ { arrival_city_name } }/g, localeField(segment.arrival_airport.city, 'name'))
            .replace(/{ { arrival_airport_code } }/g, segment.arrival_airport_code)
            .replace(/{ { max_quantity } }/g, that.meal_item.max_quantity);

        $.each(that.passengers, function(i, passenger) {
            const key = '{ { passenger_%s_quantity } }'.replace('%s', passenger.id);
            html = html.replace(key, (that.quantity > 0 ? passenger.quantity : 1));
        });

        return html;
    }
}